import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ErrorModel, ProductActions, ProductReferencesConnector } from "@spartacus/core";
import { Observable, of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";


@Injectable()
export class CustomProductReferencesEffects {

  loadProductReferences$: Observable<
    | ProductActions.LoadProductReferencesSuccess
    | ProductActions.LoadProductReferencesFail> = createEffect(() => this.actions$.pipe(
      ofType(ProductActions.LOAD_PRODUCT_REFERENCES),
      map((action: ProductActions.LoadProductReferences) => action.payload),
      mergeMap((payload) => {
        return this.productReferencesConnector
          .get(payload.productCode, payload.referenceType, payload.pageSize)
          .pipe(
            map((data) => {
              return new ProductActions.LoadProductReferencesSuccess({
                productCode: payload.productCode,
                list: data,
              });
            }),
            catchError((_error) =>
              of(
                new ProductActions.LoadProductReferencesFail({
                  message: payload.productCode,
                } as ErrorModel)
              )
            )
          );
      })
    ));

  constructor(
    private actions$: Actions,
    private productReferencesConnector: ProductReferencesConnector
  ) { }
}
